<script>
    import Sectors from '../../../../data/Sectors';
    import AdminList from '../_List';
    import TableRow from './_Row';

    export default {
        extends: AdminList,

        data: () => ({
            TableRow,
            removeRow: null,
            removeModal: {
                text: 'Soll dieses Assessment wirklich gelöscht werden?',
                button: 'Assessment löschen',
                error: 'Das Assessment konnte nicht gelöscht werden.',
            },
        }),

        asyncComputed: {
            cols: {
                get: async () => {
                    if (await Sectors.hasSectors()) {
                        return ['Score', 'Kunde', 'Branche', 'Adresse', 'Erstellt', ''];
                    }

                    return ['Score', 'Kunde', 'Adresse', 'Erstellt', ''];
                },
                default: ['Score', 'Kunde', 'Adresse', 'Erstellt', ''],
            },
        },
    };
</script>
